import { render, staticRenderFns } from "./EstimatorList.vue?vue&type=template&id=f84115a4&scoped=true"
import script from "./EstimatorList.vue?vue&type=script&lang=js"
export * from "./EstimatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84115a4",
  null
  
)

export default component.exports